import ConfirmDialog from '../lib/ConfirmDialog.js';
import el from '@finn-no/create-element';
export default {
    dependencies: ['$element'],
    callable(ele) {
        // FIXME: This controller currently depends on a slider being available

        const slider = ele.slider;
        const content = document.createElement('div');
        const inputs = ele.querySelectorAll("input[type='number']");
        const button = ele.querySelector('[data-button]');
        const startInputEle = inputs[0];
        const endInputEle = inputs[1];
        const suffix = startInputEle.getAttribute('data-output-suffix');
        let dialogStartInputEle;
        let dialogEndInputEle;
        let messageEle;
        const title = ele
            .querySelector('[data-label]')
            .getAttribute('data-label');
        const dialog = new ConfirmDialog(title, content, 'Ferdig', 'Avbryt', {
            onDismiss(reason) {
                if (reason === ConfirmDialog.POSITIVE_LABEL) {
                    return !submit();
                }
            },
        });

        button.addEventListener('click', openDialog);

        function openDialog(event) {
            event.stopPropagation();

            const nameFrom = `dialog_${startInputEle.name}`;
            const nameTo = `dialog_${endInputEle.name}`;
            messageEle = el('p.mhn.cherry');
            const fromInput = el('input.rightify', {
                id: nameFrom,
                name: 'from',
                type: 'number',
                step: startInputEle.step,
                value: startInputEle.value,
                min: 0,
                pattern: '\\d*',
                style: 'width: 100%',
            });
            const formEle = el(
                'form',
                { novalidate: '', onsubmit: handleSubmit },
                el(
                    'div.phm',
                    null,
                    el(
                        'p.man.ptm',
                        null,
                        el('label', { for: nameFrom }, 'Fra ', suffix),
                        fromInput
                    ),
                    el(
                        'p.man.ptm',
                        null,
                        el('label', { for: nameTo }, 'Til ', suffix),
                        el('input.rightify', {
                            id: nameTo,
                            name: 'to',
                            type: 'number',
                            step: startInputEle.step,
                            value: endInputEle.value,
                            min: 0,
                            pattern: '\\d*',
                            style: 'width: 100%',
                        })
                    ),
                    messageEle,
                    el(
                        'button.visuallyhidden',
                        { tabindex: -1, 'aria-hidden': true },
                        'Ferdig'
                    )
                )
            );
            content.innerHTML = '';
            content.appendChild(formEle);

            dialogStartInputEle = formEle.elements[nameFrom];
            dialogEndInputEle = formEle.elements[nameTo];

            dialog.show();
            // Focusing leads to broken behavior on iOS, so disable
            if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                fromInput.focus();
            }
        }

        function handleSubmit(event) {
            event.preventDefault();
            const success = submit();
            if (success) {
                dialog.hide();
            }
        }

        function submit() {
            const success = submitNewValues();
            if (!success) {
                return false;
            }
            // make sure on-screen keyboard pops down when hitting "go" on iOS
            document.activeElement.blur();
            return true;
        }

        function defaultIfBlank(value, defaultValue) {
            return value === '' ? Number(defaultValue) : Number(value);
        }

        function submitNewValues() {
            const startValue = dialogStartInputEle.value;
            const endValue = dialogEndInputEle.value;
            const minValue = startInputEle.getAttribute('min');
            const maxValue = startInputEle.getAttribute('max');

            let actualStartValue = defaultIfBlank(startValue, minValue);
            let actualEndValue = defaultIfBlank(endValue, maxValue);

            if (actualStartValue > actualEndValue) {
                if (startValue !== '' && endValue !== '') {
                    messageEle.textContent = `«Fra ${suffix}» må være lavere enn «Til ${suffix}».`;
                    if (document.activeElement !== dialogEndInputEle) {
                        dialogStartInputEle.focus();
                    }
                    return false;
                } else if (startValue !== '' && endValue === '') {
                    actualEndValue = Infinity;
                } else if (startValue === '' && endValue !== '') {
                    actualStartValue = -Infinity;
                }
            }

            slider.setStartValue(actualStartValue);
            slider.setEndValue(actualEndValue);

            return true;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/rangeWidget.js